import { createSlice } from "@reduxjs/toolkit";
import {
  fetchStaffGroupMembers,
  fetchStaffGroupMemberById,
  createStaffGroupMember,
  updateStaffGroupMember,
  deleteStaffGroupMember,
} from "@/apis/security/staffGroupMemberApi";

const slice = createSlice({
  name: "staffGroupMembers",
  initialState: {
    list: [],
    current: null,
    listLoading: false,
    currentLoading: false,
    saveLoading: false,
    updateLoading: false,
    deleteLoading: false,
  },
  reducers: {
    clearCurrentMember(state) {
      state.current = null;
    },
  },
  extraReducers: (b) => {
    b
      // LIST
      .addCase(fetchStaffGroupMembers.pending,   (s) => { s.listLoading = true })
      .addCase(fetchStaffGroupMembers.fulfilled, (s,a)=> { s.list = a.payload; s.listLoading = false })
      .addCase(fetchStaffGroupMembers.rejected,  (s) => { s.listLoading = false })

      // GET BY ID
      .addCase(fetchStaffGroupMemberById.pending,   (s) => { s.currentLoading = true })
      .addCase(fetchStaffGroupMemberById.fulfilled, (s,a)=> { s.current = a.payload; s.currentLoading = false })
      .addCase(fetchStaffGroupMemberById.rejected,  (s) => { s.currentLoading = false })

      // CREATE
      .addCase(createStaffGroupMember.pending,   (s) => { s.saveLoading = true })
      .addCase(createStaffGroupMember.fulfilled, (s,a)=> { s.list.push(a.payload); s.saveLoading = false })
      .addCase(createStaffGroupMember.rejected,  (s) => { s.saveLoading = false })

      // UPDATE
      .addCase(updateStaffGroupMember.pending,   (s) => { s.updateLoading = true })
      .addCase(updateStaffGroupMember.fulfilled, (s,a)=> {
        s.list = s.list.map(m => m.staffGroupMembersID === a.payload.staffGroupMembersID ? a.payload : m);
        s.updateLoading = false;
      })
      .addCase(updateStaffGroupMember.rejected,  (s) => { s.updateLoading = false })

      // DELETE
      .addCase(deleteStaffGroupMember.pending,   (s) => { s.deleteLoading = true })
      .addCase(deleteStaffGroupMember.fulfilled, (s,a)=> {
        s.list = s.list.filter(m => m.staffGroupMembersID !== a.payload);
        s.deleteLoading = false;
      })
      .addCase(deleteStaffGroupMember.rejected,  (s) => { s.deleteLoading = false });
  },
});

export const { clearCurrentMember } = slice.actions;
export default slice.reducer;
